import { NewsDetails } from "@/@types";
import { NewsDetailsResponse } from "../../news/models/NewsDetailsResponse";

export function mapNewsDetails(response: NewsDetailsResponse): NewsDetails {
    return {
        title: response.title,
        description: response.description,
        longDescription: response.long_description,
        date: response.date,
        image: response.image,
        media: response.media,
        slug: response.slug,
        metaTitle: response.meta_title,
        metaDescription: response.meta_description,
        metaKeywords: response.meta_keywords,
        category: {
            name: response.category.name,
            slug: response.category.slug,
        }
    }
}